import { useRef, useState, useEffect, } from 'react';
import { CatmullRomCurve3 } from 'three';
import { motion, AnimatePresence } from 'framer-motion';
import { A11yAnnouncer } from '@react-three/a11y';
import SurpriseScene from '../components/surprise/SurpriseScene';

const Surprise = (props) => {
  const { windowHeight, siteData, setActiveToolTip } = props;

  const [coinIsTossed, setCoinIsTossed] = useState(false);
  const [isReadyToGo, setIsReadyToGo] = useState(false);
  const [isTravellingOut, setIsTravellingOut] = useState(false);
  const [coinModel, setCoinModel] = useState({ unset: true });
  
  const coinMesh = useRef();
  const [cameraPos, setCameraPos] = useState({
    unset: true
  });

  useEffect(() => { 
		if (coinIsTossed === true) {
			if (isReadyToGo === true) {
				setActiveToolTip(siteData.surpriseMe?.postCoinTossInfoText ? siteData.surpriseMe.postCoinTossInfoText : `Click anywhere on the screen when you're ready to leave the well!`);
			} else {
				// setActiveToolTip('');
			}
		} else {
			setActiveToolTip(siteData.surpriseMe?.infoText ? siteData.surpriseMe.infoText : `This land is full of sacred wells. Most are forgotten, but all are portals! Click on the well to toss a coin and receive a surprise!`);
    }
  }, [coinIsTossed, setActiveToolTip, isReadyToGo, siteData.surpriseMe]);

	useEffect(() => {
		setActiveToolTip(siteData.surpriseMe?.infoText ? siteData.surpriseMe.infoText : `This land is full of sacred wells. Most are forgotten, but all are portals! Click on the well to toss a coin and receive a surprise!`);
	}, [siteData.surpriseMe, setActiveToolTip,]);

  const camera = useRef();
  const group = useRef();
  const curve = useRef(new CatmullRomCurve3(
    [0, 0, 0],
    [3, 0, 0],
    false,
    'centripetal',
    [0, -2, 0]
  ));
  const fog = useRef();

  const handleClick = () => {
    if (isReadyToGo === true && isTravellingOut === false) {
      setIsTravellingOut(true);
      setTimeout(() => {
        if (siteData.fragments?.entries) {
          if (siteData.fragments.entries[0]) {
            const randomIndex = Math.floor(Math.random() * (siteData.fragments.entries.length - 0.01));
            props.navigate(`/place-oddity/${siteData.fragments.entries[randomIndex].title_slug}-${siteData.fragments.entries[randomIndex]._created}`);
          }
        }
      }, 1200);
    }
  }

  const tossCoin = (e) => {
    if (camera.current?.position && coinIsTossed === false) {
      setCameraPos({
        unset: true
      });
      setCameraPos({ ...camera.current.position, unset: false });
      setCoinIsTossed(true);
      setTimeout(() => {
        setIsReadyToGo(true);
      }, 1000);
    }
  }

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				height: windowHeight + 'px',
				cursor: isReadyToGo === true ? 'pointer' : null
			}}
			transition={{ duration: 0.3 }}
			className="view--surprise"
			onClick={handleClick}
		>
			<SurpriseScene
				{...props}
				coinIsTossed={coinIsTossed}
				coinModel={coinModel}
				isReadyToGo={isReadyToGo}
				setCoinIsTossed={setCoinIsTossed}
				setCoinModel={setCoinModel}
				setIsReadyToGo={setIsReadyToGo}
				isTravellingOut={isTravellingOut}
				setIsTravellingOut={setIsTravellingOut}
				camera={camera}
				group={group}
				curve={curve}
				fog={fog}
				coinMesh={coinMesh}
				cameraPos={cameraPos}
				setCameraPos={setCameraPos}
				tossCoin={tossCoin}
			/>
			<A11yAnnouncer />
			<AnimatePresence>
				{
					isTravellingOut === true &&
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						animate={{ opacity: 1, scale: 12 }}
						exit={{ opacity: 0, scale: 12 }}
						transition={{ duration: 1.2 }}
						className="surprise__glow"
						style={{
							position: 'fixed',
							zIndex: 2,
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							pointerEvents: 'none',
							background: 'radial-gradient(white, transparent)'
						}}
					>
					</motion.div>
				}
			</AnimatePresence>
		</motion.div>
  )
}

export default Surprise;